<template>
    <Header
        elements="6"
        current="3"
    ></Header>
    <NumberPageBlock
        deadline_word="Deadline"
        form_type="REV"
        part_url="trademark-revival"
        part_url_next="step-2/first-class"
    ></NumberPageBlock>
</template>

<script>
import Header from '@/components/Header-Short-New.vue'
import NumberPageBlock from '@/components/blocks/NumberPageBlock.vue'
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        NumberPageBlock
    },
    data() {
        return {}
    },
    mounted() {
        to_top()
        this.$store.commit('header/setTotal', 0)
    }
}
</script>
